<script>
  import SmallTopNavigation from "./SmallTopNavigation.svelte";
  import {fly} from "svelte/transition"
	let MenuToggle = $derived(false);
  import ToggleButton from "@components/ToggleButton.svelte"
  import SmallMainMenu from "./SmallMainMenu.svelte";
  const Logo = "/assets_default/icons/logo.svg"

  let smallMainMenu;

  // Menu Toggle
  function buttonToggle () {
    MenuToggle = !MenuToggle
    MenuToggle ? document.body.style.overflow = 'hidden' : document.body.style.overflow = '';
       if (smallMainMenu) {
      smallMainMenu.closeMenu();
    }
  }
</script>
<header id="header">
  <div class="small-header">
    <div class="menu-content-bg" style:display={MenuToggle ? 'block' : 'none'}></div>
    <a href="/" class="small-header-logo">
      <img src={Logo} alt="Minna no Ginko">
    </a>

    <div class="small-header-toggle">
    <ToggleButton {MenuToggle} clickEvent={buttonToggle} />
    </div>

  </div>

  <SmallMainMenu bind:this={smallMainMenu} />

  {#if MenuToggle}
    <div
      in:fly={{y:20,delay:50,duration:300}}
      out:fly={{y:-20,delay:50,duration:300}}
      class="small-header-top">
      <SmallTopNavigation />
      <div class="small-header-underarea">
        <div class="small-top-button block:center">
          <a href="https://minna-no-ginko.go.link/bwUec"
            target="_blank"
            class="owd-button owd-button:large owd-button:primary"
            id="common-sp-hamburger-app"
            >アプリをダウンロード</a>
        </div>
        <!-- <SmallHeaderCloseLabel buttonToggle={buttonToggle} /> -->
      </div>
    </div>
  {/if}

</header>


<style lang="scss">

  :root{
    --small-header-height: 45px;
  }
    .menu-content{
    &-bg{
      position: absolute;
      top: 0;
      left: 0;
      background-color: var(--black-opacity5);
      width: 100%;
      height: 100vh;
      z-index: -1;
      display: none;
    }
  }
  .small-header {
    background: var(--primary-white);
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    height: var(--small-header-height);
    align-items: center;
    // border-bottom: solid 1px var(--black-opacity1);
    &-logo {
      img{
        width: 140px;
        display: block;
      }
    }

    &-top {
      position: absolute;
      top: 44px;
      width: 100%;
      // height: 100svh;
      max-height: calc(100svh - var(--small-header-height));
      padding-bottom: 40px;
      background: #fff;
      // overflow: hidden;
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;
      left: 0;
      z-index: 5;
    }

    &-underarea {
      // padding-bottom: 48px;
      margin-top: 40px;
    }

    &-toggle {
      position: relative;
      right: -1px;
    }
  }

  // .small-top-button {
  //   margin-bottom: 40px;
  // }

</style>
